module.exports = __webpack_public_path__ + "static/media/pic_02.7f8b5450.png";